import { useState } from 'react';
import { AppSidebar } from './AppSidebar';
import NotificationBell from './NotificationBell';

interface AppLayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

export function AppLayout({ children, noPadding }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <AppSidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Top bar */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center px-6 shrink-0 gap-4">
          <div className="flex-1" />
          <div className="flex items-center gap-2">
            <NotificationBell />
          </div>
        </header>

        {/* Page content */}
        <main className={`flex-1 overflow-hidden ${noPadding ? 'flex flex-col' : 'overflow-y-auto p-6 lg:p-8'}`}>
          {children}
        </main>
      </div>
    </div>
  );
}
